import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { GovRow } from "./GovRow";
import { SpwkGovStep } from "./GovRowHelper";
import { HisBasic } from "./HisBasic";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class GovRowParser_檢查時期 {// 問卷類別1: 檢查時期  只會是 "0000" 格式

  static ConvertToHisRow(func_code: string, step: SpwkGovStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): GovRow {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_檢查時期) {
      throw new Error("684616 必須是 CHAPTER_檢查時期 !!!");
    }

    const gov_row: GovRow = new GovRow(基本檔, step.Gov問卷類別);

    gov_row.問題編號 = "01";


    let his_code = meta_table.Get檢查時期HisCode(func_code);

    var check_arry = new Array(4).fill("0");

    if (his_code !== "") {
      const n = parseInt(his_code);
      if (isNaN(n)) {
        throw new_ErrorAlert("4949497 申報 檢查時期 idx 必須為數字 !!!");
      }
      if (n === 2) {
        check_arry[2] = "1";
      } else if (n === 3) {
        check_arry[1] = "1";
      } else {
        const idx = (n - 1);// 1、2、3、4 => 0、1、2、3 (his_code-1 才是 ArrayIndex);
        check_arry[idx] = "1";
      }
    }

    gov_row.答題內容 = check_arry.join("");// "0000";

    return gov_row;
  }

}
